var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { transient, autoinject } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { HttpMethods, BrandNotificationTypes, BodyTypes } from "../../../../../models/modules/lotteryplatofrm.models";
import * as Enumerable from "linq";
var BrandNotifications = /** @class */ (function (_super) {
    __extends(BrandNotifications, _super);
    function BrandNotifications() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prefix = "{{";
        _this.suffix = "}}";
        return _this;
    }
    Object.defineProperty(BrandNotifications.prototype, "isReadonly", {
        get: function () {
            return !this.item.isEditable;
        },
        enumerable: false,
        configurable: true
    });
    BrandNotifications.prototype.onItemChanged = function () {
        var _this = this;
        this.item.brandNotifications.forEach(function (b) {
            b.notificationParameterKeyValuePairs = _this.getKeyValuePairsFromJson(b.notificationParameters);
            if (b.brandNotificationType == BrandNotificationTypes.API) {
                b.deliveryParameterKeyValuePairs = _this.getKeyValuePairsFromJson(b.deliveryParameters);
            }
            else if (b.brandNotificationType == BrandNotificationTypes.Email) {
                _this.initializeForEmail(b.notificationParameterKeyValuePairs);
            }
        });
    };
    BrandNotifications.prototype.initializeForEmail = function (notificationParameterKeyValuePairs) {
        var e_1, _a;
        var list = ["Subject", "SmtpHost", "SmtpPort", "ImapHost", "ImapPort", "EmailFrom", "Password"];
        try {
            for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                var item = list_1_1.value;
                var value = Enumerable.from(notificationParameterKeyValuePairs).firstOrDefault(function (x) { return x.key.toLowerCase() == item.toLowerCase(); });
                if (!value)
                    notificationParameterKeyValuePairs.push({ key: item, value: "" });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    BrandNotifications.prototype.getJsonFromParameterKeyValuePairs = function (parameterKeyValuePairs) {
        if (!Array.isArray(parameterKeyValuePairs)) {
            return "";
        }
        var obj = {};
        parameterKeyValuePairs.forEach(function (p) { return obj[p.key] = p.value; });
        return JSON.stringify(obj);
    };
    BrandNotifications.prototype.getKeyValuePairsFromJson = function (json) {
        if (!json) {
            return [];
        }
        var obj;
        try {
            obj = JSON.parse(json);
        }
        catch (_a) {
            return [];
        }
        var keyValuePairs = Object.keys(obj).map(function (k) {
            return {
                key: k,
                value: obj[k]
            };
        });
        return keyValuePairs;
    };
    BrandNotifications.prototype.checkBrandNotificationValues = function () {
        var _this = this;
        if (this.item && this.item.brandNotifications)
            this.item.brandNotifications.forEach(function (b) {
                b.notificationParameters = _this.getJsonFromParameterKeyValuePairs(b.notificationParameterKeyValuePairs);
                if (b.brandNotificationType == BrandNotificationTypes.API) {
                    b.deliveryParameters = _this.getJsonFromParameterKeyValuePairs(b.deliveryParameterKeyValuePairs);
                }
                if (b.httpMethod == 0) {
                    b.httpMethod = null;
                }
            });
    };
    BrandNotifications.prototype.onBrandNotificationTypeChanged = function (event, brandNotification) {
        var item = event.detail.item;
        var oldItem = event.detail.oldItem;
        if (oldItem && item.id != oldItem.id) {
            brandNotification.contentTemplate = "";
        }
    };
    Object.defineProperty(BrandNotifications.prototype, "brandNotificationTypes", {
        get: function () {
            if (!this._brandNotificationTypes) {
                this._brandNotificationTypes = this.getItemSourceFromEnum(BrandNotificationTypes);
            }
            return this._brandNotificationTypes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandNotifications.prototype, "httpMethods", {
        get: function () {
            if (!this._httpMethods) {
                this._httpMethods = this.getItemSourceFromEnum(HttpMethods);
            }
            return this._httpMethods;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandNotifications.prototype, "bodyTypes", {
        get: function () {
            if (!this._bodyTypes) {
                this._bodyTypes = this.getItemSourceFromEnum(BodyTypes);
            }
            return this._bodyTypes;
        },
        enumerable: false,
        configurable: true
    });
    BrandNotifications.prototype.contextParameters = function () {
        return [{
                name: "id",
                value: "id"
            }].concat(this.item.contextParameters);
    };
    BrandNotifications.prototype.getItemSourceFromEnum = function (obj) {
        return Object.keys(obj)
            .map(function (k) { return obj[k]; })
            .filter(function (v) { return typeof v === 'string'; })
            .map(function (v) {
            return {
                id: Number(obj[v]),
                name: v
            };
        });
    };
    BrandNotifications.prototype.removeBrandNotification = function (index) {
        this.item.brandNotifications.splice(index, 1);
    };
    BrandNotifications.prototype.addBrandNotification = function () {
        this.item.brandNotifications.push(this.defaultBrandNotification);
    };
    BrandNotifications.prototype.addNotificationParameter = function (brandNotification) {
        if (!Array.isArray(brandNotification.notificationParameterKeyValuePairs)) {
            brandNotification.notificationParameterKeyValuePairs = [];
        }
        brandNotification.notificationParameterKeyValuePairs.push(this.defaultParameter);
    };
    BrandNotifications.prototype.addDeliveryParameter = function (brandNotification) {
        if (!Array.isArray(brandNotification.deliveryParameterKeyValuePairs)) {
            brandNotification.deliveryParameterKeyValuePairs = [];
        }
        brandNotification.deliveryParameterKeyValuePairs.push(this.defaultParameter);
    };
    BrandNotifications.prototype.removeNotificationParameter = function (index, brandNotification) {
        brandNotification.notificationParameterKeyValuePairs.splice(index, 1);
    };
    BrandNotifications.prototype.removeDeliveryParameter = function (index, brandNotification) {
        brandNotification.deliveryParameterKeyValuePairs.splice(index, 1);
    };
    Object.defineProperty(BrandNotifications.prototype, "defaultBrandNotification", {
        get: function () {
            return {
                brandId: 0,
                brandNotificationType: 0,
                notificationUrl: null,
                deliveryUrl: null,
                httpMethod: 0,
                notificationParameters: null,
                notificationHttpMethod: null,
                deliveryHttpMethod: null,
                notificationBodyType: null,
                deliveryBodyType: null,
                deliveryParameters: null,
                contentTemplate: null,
                isActive: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandNotifications.prototype, "defaultParameter", {
        get: function () {
            return {
                key: "",
                value: ""
            };
        },
        enumerable: false,
        configurable: true
    });
    BrandNotifications.prototype.addValue = function (event, myValue) {
        event.preventDefault();
        event.stopPropagation();
        this.insertAtCursor("".concat(this.prefix).concat(myValue).concat(this.suffix));
    };
    BrandNotifications.prototype.insertAtCursor = function (myValue) {
        var myField = document.activeElement;
        var isInputText = myField instanceof HTMLInputElement && myField.type == 'text';
        var isContentEditable = myField instanceof HTMLDivElement && myField.className && myField.className.indexOf("ql-editor") != -1;
        if (isInputText) {
            var textBox = $(myField).closest("text-box").get(0);
            if (!textBox)
                return;
            //IE support
            if (document.selection) {
                myField.focus();
                var sel = document.selection.createRange();
                sel.text = myValue;
            }
            //MOZILLA and others
            else if (myField.selectionStart || myField.selectionStart == '0') {
                var startPos = myField.selectionStart;
                var endPos = myField.selectionEnd;
                textBox.au.controller.viewModel.value = myField.value.substring(0, startPos)
                    + myValue
                    + myField.value.substring(endPos, myField.value.length);
                myField.selectionStart = startPos + myValue.length;
                myField.selectionEnd = startPos + myValue.length;
            }
            else {
                textBox.au.controller.viewModel.value += myValue;
            }
        }
        else if (isContentEditable) {
            var selection = window.getSelection();
            var range = selection.getRangeAt(0);
            range.deleteContents();
            var node = document.createTextNode(myValue);
            range.insertNode(node);
            for (var position = 0; position != myValue.length; position++) {
                selection.modify("move", "right", "character");
            }
        }
    };
    BrandNotifications = __decorate([
        autoinject,
        transient()
    ], BrandNotifications);
    return BrandNotifications;
}(ChildComponent));
export { BrandNotifications };
